const music         = document.querySelector('.music__audio');
const currentTime   = document.querySelector('.current-time');
const musicDuration = document.querySelector('.song-duration');
const seekBar       = document.querySelector('.seek-bar');
const musicsItem    = document.querySelectorAll('.music');
const allMusic      = document.querySelectorAll('.music__audio');

musicsItem.forEach(item => {
  const musicControl = item.querySelector('.music__controls');
  const musicFile = item.querySelector('audio');

  if(musicControl) {
    musicControl.addEventListener('click', (e) => {
      stopOtherMusic(musicControl);

      musicControl.classList.toggle('pause');

      if(musicControl.classList.contains('pause')) {
        musicFile.play();
      } else {
        musicFile.pause();
      }
    })
  }
})

// formation time in min and second format
const formatTime = (time) => {
  let min = Math.floor(time / 60);
  if (min  < 10) {
    min = `0${min}`;
  }

  let sec = Math.floor(time % 60);
  if (sec < 10) {
    sec = `0${sec}`;
  }

  return `${min} : ${sec}`;
}

// setup Music
if(seekBar) {
  const setMusic = (i) => {
    seekBar.value = 0; // set range slider value

    currentTime.innerHTML = '00:00';
    setTimeout(() =>{
      seekBar.max = music.duration;
      musicDuration.innerHTML = formatTime(music.duration);
    }, 300)
  }

  setMusic(0);

  // Seek-bar
  setInterval(() => {
    seekBar.value = music.currentTime;
    currentTime.innerHTML = formatTime(music.currentTime);
  }, 200)

  seekBar.addEventListener('change', () => {
    music.currentTime = seekBar.value;
  })
}

// Multiplay
function stopOtherMusic(except) {
  [...document.querySelectorAll('audio')].forEach(item => {
    item.pause();
  });

  [...document.querySelectorAll('.music__controls')].filter(e => e !== except).forEach(item => {
    item.classList.remove('pause');
  })
}

allMusic.forEach(item => {
  item.addEventListener('ended', (e) => {
    stopOtherMusic();
    playNextInList(item);
  });
})

function playNextInList(audio){
  const musicsList = audio.closest('.musics');

  if ( !musicsList ) return;

  const musicsItem    = audio.closest('.musics__item');
  const itemsInList   = [...musicsList.querySelectorAll('.musics__item')];
  const index         = [...musicsItem.parentNode.children].indexOf(musicsItem);
  const filteredItems = itemsInList.slice(index + 1, itemsInList.length);

  if ( !filteredItems.length ) return;

  const musicControl = filteredItems[0].querySelector('.music__controls');
  musicControl.click();
}